module.exports = __webpack_public_path__ + "img/8_uk.c22e8cc6.svg";